export const GET_EMERGENCY_DTRF_LIST = "GET_EMERGENCY_DTRF_LIST"
export const GET_EMERGENCY_DTRF_LIST_FAIL = "GET_EMERGENCY_DTRF_LIST_FAIL"
export const GET_EMERGENCY_DTRF_LIST_SUCCESS = "GET_EMERGENCY_DTRF_LIST_SUCCESS"
export const GET_EMERGENCY_DTRF_LIST_RESET = "GET_EMERGENCY_DTRF_LIST_RESET"

export const getEmergencyDtrfList = (params) => {
    return { type: GET_EMERGENCY_DTRF_LIST, params }
}

export const getEmergencyDtrfListSuccess = (response) => {
    return { type: GET_EMERGENCY_DTRF_LIST_SUCCESS, response }
}

export const getEmergencyDtrfListFail = (response) => {
    return { type: GET_EMERGENCY_DTRF_LIST_FAIL, response }
}

export const getEmergencyDtrfListResetState = () => {
    return { type: GET_EMERGENCY_DTRF_LIST_RESET }
}